export default class UIComponent {

    uiComponent = {};

    constructor(component) {
        this.uiComponent = {
            component: component
        }
    }

    addChild(childComponent) {
        if(!this.uiComponent.hasOwnProperty("children")) {
            this.uiComponent.children = [];
        }

        this.uiComponent.children.push(childComponent);
    }

    addChildren(childComponents) {
        if(!this.uiComponent.hasOwnProperty("children")) {
            this.uiComponent.children = [];
        }

        this.uiComponent.children = this.uiComponent.children.concat(childComponents);
    }

    getChildren() {
        if(this.uiComponent.hasOwnProperty("children")) {
            return this.uiComponent.children;
        }

        return false;
    }

    hasChildren() {
        if(this.uiComponent.hasOwnProperty("children") && this.uiComponent.children.length > 0) {
            return true;
        }

        return false;
    }

    addRootProperty(property, value) {
        this.uiComponent[property] = value;
    }

    addFieldOption(property, value) {
        if(!this.uiComponent.hasOwnProperty("fieldOptions")) {
            this.addRootProperty("fieldOptions", {});
        }

        this.uiComponent.fieldOptions[property] = value;
    }

    addFieldOptionAttribute(property, value) {
        if(!this.uiComponent.hasOwnProperty("fieldOptions")) {
            this.addRootProperty("fieldOptions", {});
        }
        if(!this.uiComponent.fieldOptions.hasOwnProperty("attrs")) {
            this.addFieldOption("attrs", {});
        }

        this.uiComponent.fieldOptions.attrs[property] = value;
    }

    addFieldOptionProperty(property, value) {
        if(!this.uiComponent.hasOwnProperty("fieldOptions")) {
            this.addRootProperty("fieldOptions", {});
        }
        if(!this.uiComponent.fieldOptions.hasOwnProperty("props")) {
            this.addFieldOption("props", {});
        }

        this.uiComponent.fieldOptions.props[property] = value;
    }

    addErrorOption(property, value) {
        if(!this.uiComponent.hasOwnProperty("errorOptions")) {
            this.uiComponent.errorOptions = {};
        }

        this.uiComponent.errorOptions[property] = value;
    }

    addErrorOptionAttribute(property, value) {
        if(!this.uiComponent.hasOwnProperty("errorOptions")) {
            this.addRootProperty("errorOptions", {});
        }
        if(!this.uiComponent.errorOptions.hasOwnProperty("attrs")) {
            this.addErrorOption("attrs", {});
        }

        this.uiComponent.errorOptions.attrs[property] = value;
    }

    addErrorOptionProperty(property, value) {
        if(!this.uiComponent.hasOwnProperty("errorOptions")) {
            this.addRootProperty("errorOptions", {});
        }
        if(!this.uiComponent.errorOptions.hasOwnProperty("props")) {
            this.addErrorOption("props", {});
        }

        this.uiComponent.errorOptions.props[property] = value;
    }

    addDisplayOption(property, value) {
        if(!this.uiComponent.hasOwnProperty("displayOptions")) {
            this.addRootProperty("displayOptions", {});
        }

        this.uiComponent.displayOptions[property] = value;
    }

    getUISchema() {
        let listeners = null;

        // JSON.parse(JSON.stringify(...)) would result in functions being removed. This behavior would destroy all event listener functions, therefore these need to be copied before.
        if(this.uiComponent.hasOwnProperty("fieldOptions") && this.uiComponent.fieldOptions.hasOwnProperty("on")) {
            listeners = this.uiComponent.fieldOptions.on;
        }
        var shadowSchema = JSON.parse(JSON.stringify(this.uiComponent));

        if(listeners !== null) {
            shadowSchema.fieldOptions.on = listeners;
        }

        if(this.hasChildren()) {
            var children = this.getChildren();
            for(var child in children) {
                shadowSchema.children[child] = children[child].getUISchema();
            }
        }

        return shadowSchema;
    }

    printUISchema() {
        console.log(this.getUISchema());
    }
}